interface ResultViewProps {
  score: number;
  total: number;
  accentColor: string;
  onRetry: () => void;
  onRetryWrong?: () => void;
  onHome: () => void;
}

export function ResultView({
  score, total, accentColor, onRetry, onRetryWrong, onHome,
}: ResultViewProps) {
  const percent = total > 0 ? Math.round((score / total) * 100) : 0;
  const wrong = total - score;

  const message = percent >= 80 ? "素晴らしい！" : percent >= 50 ? "あと少し！" : "もう一度挑戦！";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden", background: "#f5f5f5" }}>
      {/* Header */}
      <div style={{ background: "#fff", borderBottom: "1px solid #e8e8e8", padding: "16px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#333" }}>演習結果</div>
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        {/* Score section */}
        <div style={{ background: "#fff", padding: "32px 20px", textAlign: "center" }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#333", marginBottom: 16 }}>{message}</div>

          {/* Stats row */}
          <div style={{ display: "flex", justifyContent: "center", gap: 40, marginBottom: 24 }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#2ecc71" }}>正解</div>
              <div style={{ fontSize: 40, fontWeight: 700, color: "#333" }}>{score}</div>
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#ff5a7e" }}>ミス</div>
              <div style={{ fontSize: 40, fontWeight: 700, color: "#333" }}>{wrong}</div>
            </div>
          </div>

          {/* Progress bar */}
          <div style={{ maxWidth: 300, margin: "0 auto" }}>
            <div className="progress-bar-container" style={{ height: 12 }}>
              <div className="segment" style={{ width: `${percent}%`, background: "#2ecc71" }} />
              <div className="segment" style={{ width: `${100 - percent}%`, background: "#ff5a7e" }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 20, fontWeight: 700, color: accentColor }}>
              正答率 {percent}%
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div style={{ padding: "20px 20px 40px", display: "flex", flexDirection: "column", gap: 12 }}>
          <button className="btn-primary" onClick={onRetry}>
            もう一度
          </button>

          {onRetryWrong && (
            <button
              className="btn-primary"
              style={{ background: "linear-gradient(180deg, #ff7eb3, #ff5a7e)" }}
              onClick={onRetryWrong}
            >
              ミスに再挑戦（{wrong}問）
            </button>
          )}

          <button className="btn-outline" onClick={onHome}>
            ホームへ
          </button>
        </div>
      </div>
    </div>
  );
}
